// extracted by mini-css-extract-plugin
module.exports = {"formSection":"styles_formSection__HJRy7","recipients":"styles_recipients__2R3EE"};